<template>
  <div>
    <a :href="`tel:${phoneNumber.attributes.phone_number}`">
      <span
        class="font-bold"
        v-text="phoneNumber.attributes.phone_number"
      />
      <span
        v-if="phoneNumber.attributes.type"
        class="font-bold"
        v-text="`(${phoneNumber.attributes.type})`"
      />
    </a>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'PhoneNumber',
  props: {
    phoneNumber: {
      type: Object,
      required: true,
    },
  },
}
</script>
